var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header",class:{ 
  'header--modalOpen': _vm.isMenuOpen, 
  'header--content-centered': _vm.isCentered 
},attrs:{"id":"header"}},[(!_vm.isMenuOpen && !_vm.hasSectionTitle)?_c('h2',{staticClass:"header__logo",class:{ 'header__logo--white': _vm.isLogoWhite}},[_vm._v(" Annamor "),_c('br'),_vm._v(" Studio. ")]):_vm._e(),(_vm.hasSectionTitle)?_c('h1',{staticClass:"header__page-title"},[_vm._v(_vm._s(_vm.title))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }